import { apiCall } from "./Interceptor";

const GET_ALL_COMPANY_PROFILES = "/analyst/get/company/dashboard";
const UPDATE_ACCOUNT_STATUS = "/analyst/update/accountStatus";
const GET_USER_DOCUMENTS = "/analyst/getDocumentsByCompany";
const EDIT_USER_PROFILE = "/analyst/update/profile";
const REUPLOAD_DOCUMENTS = "/analyst/reUpload";
const CONFIG_CONNECTION_NAME = "/config/create";
const GET_ALL_CAPACITY_LISTING_CONSUMER = "/consumer/capacity/getAllByConsumer";
const GET_ALL_CAPACITY_LISTING_GENERATOR = "/generator/capacity/getAllByPlant";
const GET_ALL_CAPACITY_LISTING_BANKING = "/banking/getAllByCompany";
const GET_ALL_TRADERS = "/trader/getAllTraders";
const GET_SPECEFIC_TRADERS = "trader/getSelected";
const GET_SPECEFIC_TRADERS_NEW = "trader/getSelectedNew";
const UPDATE_TRADER_COMPANY = "analyst/modifyTradersByCompanies";
const BANKING_LISING_LOGS = "logs/blStatusLogs";

const getAllCompanyProfiles = async () => {
  const response = await apiCall.post(GET_ALL_COMPANY_PROFILES);
  return response;
};
const updateAccountStatus = async (accStatus, id) => {
  const response = await apiCall.put(
    `${UPDATE_ACCOUNT_STATUS}?accountStatus=${accStatus}&companyId=${id}`
  );
  return response;
};
const getUserDocumentsById = async (id) => {
  const response = await apiCall.get(`${GET_USER_DOCUMENTS}?companyId=${id}`);
  return response;
};

const editUserProfile = async (data) => {
  const response = await apiCall.post(EDIT_USER_PROFILE, data);
  return response;
};
const reUploadDocuments = async (data) => {
  const response = await apiCall.post(REUPLOAD_DOCUMENTS, data);
  return response;
};
const changeConnectionName = async (data) => {
  const response = await apiCall.post(CONFIG_CONNECTION_NAME, data);
  return response;
};
const getAllCapacityListingByConsumerId = async (id) => {
  const response = await apiCall.get(
    `${GET_ALL_CAPACITY_LISTING_CONSUMER}?consumerId=${id}`
  );
  return response;
};
const getAllCapacityListingByPlantId = async (id) => {
  const response = await apiCall.get(
    `${GET_ALL_CAPACITY_LISTING_GENERATOR}?plantId=${id}`
  );
  return response;
};

const getAllCapacityListingByBankId = async (id) => {
  const response = await apiCall.get(
    `${GET_ALL_CAPACITY_LISTING_BANKING}?companyId=${id}`
  );
  return response;
};
const getAllTraders = async () => {
  const response = await apiCall.get(`${GET_ALL_TRADERS}`);
  return response;
};

const getSpeceficTrader = async (id) => {
  const response = await apiCall.get(`${GET_SPECEFIC_TRADERS}?id=${id}`);
  return response;
};

const getSpeceficTraderNew = async (id) => {
  const response = await apiCall.get(`${GET_SPECEFIC_TRADERS_NEW}?id=${id}`);
  return response;
};

const getUpdateTraderCompany = async (data) => {
  const response = await apiCall.put(`${UPDATE_TRADER_COMPANY}`, data);
  return response;
};

const getListingLogsBanking = async (id) => {
  const response = await apiCall.get(`${BANKING_LISING_LOGS}?id=${id}`);
  return response;
};

export default {
  getAllCompanyProfiles,
  updateAccountStatus,
  getUserDocumentsById,
  editUserProfile,
  reUploadDocuments,
  changeConnectionName,
  getAllCapacityListingByConsumerId,
  getAllCapacityListingByPlantId,
  getAllCapacityListingByBankId,
  getAllTraders,
  getSpeceficTrader,
  getUpdateTraderCompany,
  getListingLogsBanking,
  getSpeceficTraderNew,
};
